import Dexie from 'dexie';

// Initialize Dexie database
class FinanceDatabase extends Dexie {
  constructor() {
    super('FinanceFloDB');
    
    this.version(1)?.stores({
      transactions: '++id, userId, date, category, amount, createdAt',
      budgets: '++id, userId, category, amount, createdAt',
      goals: '++id, userId, name, targetAmount, createdAt',
      systems: '++id, userId, title, category, createdAt',
      syncQueue: '++id, table, operation, data, timestamp'
    });

    // Version 2: add bills and investments
    this.version(2)?.stores({
      transactions: '++id, userId, date, category, amount, createdAt',
      budgets: '++id, userId, category, amount, createdAt',
      goals: '++id, userId, name, targetAmount, createdAt',
      systems: '++id, userId, title, category, createdAt',
      syncQueue: '++id, table, operation, data, timestamp',
      bills: '++id, userId, billName, amount, dueDate, createdAt',
      investments: '++id, userId, symbol, name, type, createdAt'
    });
  }
}

const db = new FinanceDatabase();

/**
 * Save data to IndexedDB for offline access
 */
export const saveToOfflineStorage = async (table, data) => {
  try {
    await db?.[table]?.put(data);
    return true;
  } catch (error) {
    console.error('Failed to save to offline storage:', error);
    return false;
  }
};

/**
 * Get data from IndexedDB
 */
export const getFromOfflineStorage = async (table, userId) => {
  try {
    const data = await db?.[table]?.where('userId')?.equals(userId)?.toArray();
    return data;
  } catch (error) {
    console.error('Failed to get from offline storage:', error);
    return [];
  }
};

/**
 * Add operation to sync queue for background sync
 */
export const addToSyncQueue = async (table, operation, data) => {
  try {
    await db?.syncQueue?.add({
      table,
      operation, // 'create', 'update', 'delete'
      data,
      timestamp: new Date()?.toISOString()
    });
    return true;
  } catch (error) {
    console.error('Failed to add to sync queue:', error);
    return false;
  }
};

/**
 * Get pending sync operations
 */
export const getPendingSyncOperations = async () => {
  try {
    return await db?.syncQueue?.toArray();
  } catch (error) {
    console.error('Failed to get sync queue:', error);
    return [];
  }
};

/**
 * Clear sync queue after successful sync
 */
export const clearSyncQueue = async () => {
  try {
    await db?.syncQueue?.clear();
    return true;
  } catch (error) {
    console.error('Failed to clear sync queue:', error);
    return false;
  }
};

/**
 * Clear all offline data
 */
export const clearOfflineStorage = async () => {
  try {
    await db?.delete();
    return true;
  } catch (error) {
    console.error('Failed to clear offline storage:', error);
    return false;
  }
};

export default db;
